import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable, faSlidersH } from '@fortawesome/free-solid-svg-icons'
import LightTooltip from 'shared/light-tooltip'

const badgeStyle = { fontSize: '0.85em', cursor: 'help' }

const humanize = (key) => key
  .split('_')
  .filter(Boolean)
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  .join(' ')

// Plain-text variant for surfaces where the badge markup can't render
// legibly (e.g. dark tooltips): unwraps [col]/[cfg] markers to their
// visible text.
export const stripDescriptionMarkers = (text) => {
  if (!text) return text
  return text
    .replace(/\[col\](.*?)\[\/col\]/g, '$1')
    .replace(/\[cfg:[^\]]*\](.*?)\[\/cfg\]/g, '$1')
}

const renderDescription = (text, columnSources) => {
  if (!text) return null
  const tokens = text.split(/(\[col\].*?\[\/col\]|\[cfg:[^\]]*\].*?\[\/cfg\])/g)
  return tokens.map((token, i) => {
    const colMatch = token.match(/^\[col\](.*?)\[\/col\]$/)
    if (colMatch) {
      const colName = colMatch[1]
      const source = columnSources?.[colName]
      const tooltipContent = source && (source.source_table || source.source_column)
        ? (
          <>
            {source.source_table && <div><strong>Source Table:</strong> {source.source_table}</div>}
            {source.source_column && <div><strong>Source Column:</strong> {source.source_column}</div>}
          </>
        )
        : 'Table Column'
      return (
        <LightTooltip key={i} content={tooltipContent}>
          <span
            className="badge bg-info bg-opacity-10 text-info-emphasis fw-normal"
            style={badgeStyle}
          >
            <FontAwesomeIcon icon={faTable} className="me-1" size="xs" />
            {colName}
          </span>
        </LightTooltip>
      )
    }
    const cfgMatch = token.match(/^\[cfg:([^\]]*)\](.*?)\[\/cfg\]$/)
    if (cfgMatch) {
      const [, configKey, configValue] = cfgMatch
      const tooltipContent = (
        <span>{humanize(configKey)}: <strong>{configValue}</strong></span>
      )
      return (
        <LightTooltip key={i} content={tooltipContent}>
          <span
            className="badge bg-info bg-opacity-10 text-info-emphasis fw-normal"
            style={badgeStyle}
          >
            <FontAwesomeIcon icon={faSlidersH} className="me-1" size="xs" />
            {configValue}
          </span>
        </LightTooltip>
      )
    }
    const trimmed = token.trim()
    if (!trimmed) return <React.Fragment key={i}>{token}</React.Fragment>
    return (
      <React.Fragment key={i}>
        {token.startsWith(' ') ? ' ' : ''}
        <span>{trimmed}</span>
        {token.endsWith(' ') ? ' ' : ''}
      </React.Fragment>
    )
  })
}

export default renderDescription
